import classNames from 'classnames';
import React, { forwardRef } from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  innerHeight?: number;
}

export const ContentContainer = forwardRef<HTMLDivElement, Props>(
  ({ children, className, innerHeight, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={classNames('content-container', className)}
        {...props}
      >
        <div className="content-inner" style={{ height: innerHeight }}>
          {children}
        </div>
        <style jsx>{`
          .content-container {
            flex-grow: 1;
            overflow-x: hidden;
            overflow-y: auto;
            padding: var(--card-spacing);
            position: relative;
          }
          .content-inner {
            min-height: 100%;
            position: relative;
          }
        `}</style>
      </div>
    );
  }
);
ContentContainer.displayName = 'ContentContainer';
